import MockReferencesBooks from '../mock-data/MockReferencesBooks.json';
import { AxiosService } from 'src/services/AxiosService';

export class TrucodeReferencesService extends AxiosService {

  public async getBookReference(): Promise<ReferencesBook[] | undefined> {
      const result =  await this.axiosCall<ReferencesBook[]>({
        method: 'get',
        url: `/grouper/${this.facilityCode}/reference/book?option=SEARCH`,
      });

      if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getBookReferenceYears(book: string): Promise<number[] | undefined> {
    const result =  await this.axiosCall<number[]>({
      method: 'get',
      url: `/grouper/${this.facilityCode}/reference/book/${book}/year/`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getBookReferenceYearIssue(book: string, year: number): Promise<ReferencesBook[] | undefined> {
    const result =  await this.axiosCall<ReferencesBook[]>({
      method: 'get',
      url: `/grouper/${this.facilityCode}/reference/book/${book}/year/${year}/issue`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getReferencesArticle(articleId: string): Promise<HTMLElement | undefined> {
    const result =  await this.axiosCall<HTMLElement>({
      method: 'get',
      url: `/grouper/${this.facilityCode}/reference/article/${articleId}?partial=true`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getReferencesArticles(issueId: number): Promise<GetReferencesArticlesResponse | undefined> {
    const result =  await this.axiosCall<GetReferencesArticlesResponse>({
      method: 'get',
      url: `/grouper/reference/issue/${issueId}/article/${this.facilityCode}`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public async getReferenceBookTermSearch(book: string, term: string): Promise<GetReferenceBookTermSearchResponse | undefined> {
    const result =  await this.axiosCall<GetReferenceBookTermSearchResponse>({
      method: 'get',
      url: `/grouper/${this.facilityCode}/reference/book/${book}/${term}`,
    });

    if (result.err) {
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  public getSearchOptions(): ReferencesBook[] {
    const books: ReferencesBook[] = MockReferencesBooks;
    return books.filter(e => e.searchable)
  }

  public getBrowseOptions(): ReferencesBook[] {
    const books: ReferencesBook[] = MockReferencesBooks;
    return books.filter(e => e.browsable)
  }

}

export interface ReferencesBook {
  id: string,
  title: string,
  searchable?: boolean,
  browsable?: boolean
}

export interface GetReferencesArticlesResponse {
  Articles: ReferencesArticle[]
}

export interface ReferencesArticle {
  ID: string,
  ArticleTitle: string
}

export interface GetReferenceBookTermSearchResponse {
  name: string,
  articles: ArtifactDetails[]
}

export interface GetArticleResponse {
  details: ArtifactDetails,
  articleId: string,
  articleTitle: string
}

export interface ArtifactDetails {
  issueTitle: string,
  issueYear: string,
  issueMonth: string
}

export const trucodeReferenceService = new TrucodeReferencesService();
